import { useState } from "react";

// customHooks
// import { useMediaQuery } from "customHooks/useMediaQuery";

// data
import { shareLinkData as data } from "lib/shareLinkData";

// helpers
import { copyToClipboard } from "helpers/copyToClipboard";

// icon
import { SvgClose as Close } from "assets/icons/js/SvgClose";
import { SvgShare as Share } from "assets/icons/js/SvgShare";

// scss
import { axiosInstance } from "helpers/axiosInstance";
import { useMutation } from "react-query";
import "./style.scss";
import getImg from "helpers/getCloudinaryImage";

export const SharePopup = ({
	onRequestClose,
	ref,
	img,
	name,
	bedrooms,
}: any) => {
	// const width = useMediaQuery();

	// const isMobile = width < 1070 ? true : false;

	const [isCopiedClipboard, setIsCopiedClipboard] = useState(false);
	const getShortUrl = useMutation(
		({ url }: any) =>
			axiosInstance({
				method: "POST",
				url: "/urlshortener/create",
				headers: {
					"Content-type": "application/json",
				},
				data: {
					URL: url,
				},
			}),
		{
			onSuccess: (data: any) => {
				// set state to true
				// this is to show a que tip that the text has been copied
				// to clipboard
				setIsCopiedClipboard(true);
				// copy to clip board
				newCopyToClipBoardHandler(data?.data?.data?.SHORT_URL);
				// revert state back to false after 2.5 seconds
				setTimeout(() => {
					setIsCopiedClipboard(false);
				}, 2000);
			},
			onError: () => {
				setIsCopiedClipboard(true);
				// copy to clip board
				newCopyToClipBoardHandler(window.location.href);
				// revert state back to false after 2.5 seconds
				setTimeout(() => {
					setIsCopiedClipboard(false);
				}, 2000);
			},
		},
	);

	const copyToClipboardHandler = (url: string): void => {
		// handle multiple clicks
		if (isCopiedClipboard) return;
		getShortUrl.mutate({
			url: url,
		});
	};
	const newCopyToClipBoardHandler = async (url:string) => {
		if (
			typeof window !== "undefined" &&
			typeof window.navigator !== "undefined" &&
			typeof window.navigator.clipboard !== "undefined"
		) {
			await window.navigator.clipboard.writeText(url);
		}
	};
	const image = getImg({
		id: img,
		quality: "80",
		width: "400",
		height: "187",
	});

	return (
		<div className="share__popup" ref={ref}>
			<div className="share__popup-container">
				<div className="share__popup-top">
					<span onClick={onRequestClose}>
						<Close height={16} width={16} />
					</span>
				</div>
				<div className="share__popup-all-bottom">
					<div className="share__popup-header">
						<Share />
						<h2>Share</h2>
					</div>
					<div className="share__popup-middle">
						<div className="share__middle-img">
							<img src={image} alt="#" />
						</div>
						<div className="share__middle-detail">
							<h3>{name}</h3>
							<p>{bedrooms} Rooms</p>
						</div>
					</div>
					<div className="share__bottom-links">
						{data.map((item) => (
							<div
								onClick={() => {
									if (item.title === "Copy Link") {
										copyToClipboardHandler(window.location.href);
									} else if (item.title === "Whatsapp") {
										window.open(
											"https://api.whatsapp.com/send?text=" +
												window.location.href,
										);
									}
								}}
								key={item.title}
							>
								<span className="share-icon" key={item.id}>
									{item.icon}
								</span>
								<p>
									{isCopiedClipboard && item.title === "Copy Link"
										? "Copied"
										: item.title}
								</p>
							</div>
						))}
					</div>
				</div>
			</div>
		</div>
	);
};
